/**
 * 열화상 결함 사각형을 near-modules API(PanelDefect) 형식으로 정규화한다.
 * @param {object | null | undefined} shape
 * @returns {{ left_x: number, top_y: number, width: number, height: number } | null}
 */
export function normalizePanelDefectForApi(shape) {
  if (!shape || typeof shape !== 'object') {
    return null;
  }

  const left_x = Number(shape.left_x ?? shape.leftX);
  const top_y = Number(shape.top_y ?? shape.topY);
  const width = Number(shape.width);
  const height = Number(shape.height);

  if (
    !Number.isFinite(left_x) ||
    !Number.isFinite(top_y) ||
    !Number.isFinite(width) ||
    !Number.isFinite(height) ||
    width <= 0 ||
    height <= 0
  ) {
    return null;
  }

  return {
    left_x: Math.round(left_x),
    top_y: Math.round(top_y),
    width: Math.round(width),
    height: Math.round(height)
  };
}
